<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="年" prop="year">
                <el-date-picker v-model="queryCondition.year" value-format="yyyy" format="yyyy" type="year" placeholder="选择年" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="季度" prop="quarter">
                <ic-select clearable table="TT_QSPI_FSPI" field="QUARTER" @change="quarterChange" v-model="queryCondition.quarter" :allValues="true" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="月份" prop="month">
                <ic-select clearable table="TT_QSPI_FSPI" field="MONTH" :excludes="excludesValue" v-model="queryCondition.month" :allValues="true" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="status">
                <ic-select clearable table="TT_QSPI_FSPI" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="QSPI_FSPI_EXPORT">导出</el-button>
      </el-row>
      <el-tabs type="border-card" @tab-click="handleClick" v-model="activeName">
        <el-tab-pane label="维护" name="first">
          <el-table ref="plxTable" :data="tableData" :row-class-name="tableRowClassName" max-height="500" border highlight-current-row>
            <el-table-column align="center" label="评价期" prop="scoreStage" min-width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="onDetail(scope.row,scope.$index)">{{scope.row.scoreStage}}</el-button>
              </template>
            </el-table-column>
            <el-table-column align="center" label="Grade" prop="gradeI18n" min-width="100"></el-table-column>
            <el-table-column align="center" label="数量">
              <el-table-column align="center" :label="'Water \n Safety & \n Quality'" prop="waterSafetyAndQuality" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'3rd Party \n Audit'" prop="threeRdPartyAudit" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Gov`t \n Audit & \n Sampling'" prop="govtAuditAndSampling" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Gov`t FS \n Grading'" prop="govtFsGrading" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'CSAT \n Quality'" prop="csatQuality" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Consumer \n Feedback \n All (SC)'" prop="consumerFeedbackAllSc" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Consumer \n Feedback \n (Ops)'" prop="consumerFeedbackOps" min-width="90"></el-table-column>
            </el-table-column>
            <el-table-column align="center" label="Percentage">
              <el-table-column align="center" :label="'Water \n Safety & \n Quality'" prop="waterSafetyAndQualityPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'3rd Party \n Audit'" prop="threeRdPartyAuditPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Gov`t \n Audit & \n Sampling'" prop="govtAuditAndSamplingPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Gov`t FS \n Grading'" prop="govtFsGradingPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'CSAT \n Quality'" prop="csatQualityPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Consumer \n Feedback \n All (SC)'" prop="consumerFeedbackAllScPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Consumer \n Feedback \n (Ops)'" prop="consumerFeedbackOpsPer" min-width="90"></el-table-column>
            </el-table-column>
            <el-table-column align="center" label="月度GC" prop="gc" min-width="100"></el-table-column>
            <el-table-column align="center" label="月度品质分数" prop="qualityScore" min-width="120"></el-table-column>
            <el-table-column align="center" label="月度问卷数" prop="questionScore" min-width="120"></el-table-column>
            <el-table-column align="center" label="状态" prop="statusI18n" min-width="90"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="更新人" prop="updateUser" min-width="120"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="更新时间" prop="updateDate" min-width="120"></el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="分析" name="second">
          <el-table ref="plxTable" :data="tableData" :row-class-name="tableRowClassName" max-height="500" border highlight-current-row>
            <el-table-column align="center" label="评价期" prop="scoreStage" min-width="100"></el-table-column>
            <el-table-column align="center" label="Grade" prop="gradeI18n" min-width="100"></el-table-column>
            <el-table-column align="center" label="数量">
              <el-table-column align="center" :label="'Water \n Safety & \n Quality'" prop="waterSafetyAndQuality" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'3rd Party \n Audit'" prop="threeRdPartyAudit" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Gov`t \n Audit & \n Sampling'" prop="govtAuditAndSampling" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Gov`t FS \n Grading'" prop="govtFsGrading" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'CSAT \n Quality'" prop="csatQuality" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Consumer \n Feedback \n All (SC)'" prop="consumerFeedbackAllSc" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Consumer \n Feedback \n (Ops)'" prop="consumerFeedbackOps" min-width="90"></el-table-column>
            </el-table-column>
            <el-table-column align="center" label="Percentage">
              <el-table-column align="center" :label="'Water \n Safety & \n Quality'" prop="waterSafetyAndQualityPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'3rd Party \n Audit'" prop="threeRdPartyAuditPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Gov`t \n Audit & \n Sampling'" prop="govtAuditAndSamplingPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Gov`t FS \n Grading'" prop="govtFsGradingPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'CSAT \n Quality'" prop="csatQualityPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Consumer \n Feedback \n All (SC)'" prop="consumerFeedbackAllScPer" min-width="90"></el-table-column>
              <el-table-column align="center" :label="'Consumer \n Feedback \n (Ops)'" prop="consumerFeedbackOpsPer" min-width="90"></el-table-column>
            </el-table-column>
            <el-table-column align="center" label="月度GC" prop="gc" min-width="100"></el-table-column>
            <el-table-column align="center" label="月度品质分数" prop="qualityScore" min-width="120"></el-table-column>
            <el-table-column align="center" label="月度问卷数" prop="questionScore" min-width="120"></el-table-column>
            <el-table-column align="center" label="状态" prop="statusI18n" min-width="90">
              <template v-slot="scope">
                <span v-if="scope.row.type=='M'&&scope.row.grade!='T'">{{ scope.row.statusI18n}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="更新人" prop="updateUser" min-width="120">
              <template v-slot="scope">
                <span v-if="scope.row.type=='M'&&scope.row.grade!='T'">{{ scope.row.updateUser}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="更新时间" prop="updateDate" min-width="120">
              <template v-slot="scope">
                <span v-if="scope.row.type=='M'&&scope.row.grade!='T'">{{ scope.row.updateDate}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import fspiApi from "@/api/fspi/index";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import { fileService } from "@/api/common/file-utils";
export default {
  name: 'fspi',
  mixins: [paginationMixin],
  components: {
    IcSelect,
  },
  data() {
    return {
      activeName: "first",
      totalCount: 0,
      pages: 1,
      queryCondition: {
        status: "",
        year: "",
        quarter: "",
        month: "",
        type: "M",
        pageSize: 15,
        pageNum: 1,
      },
      detailForm: {},
      periodList: [],
      statusList: [],
      detailTable: [],
      tableData: [],
      excludesValue: []
    }
  },
  created() {
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.month) {
      to.meta.reqData.year = to.query.month.split('-')[0];
      to.meta.reqData.month = to.query.month.split('-')[1];
    }
    fspiApi.queryPage(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  methods: {
    queryData() {
      fspiApi.queryPage(this.queryCondition).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.grade === 'T') {
        return 'grey_row';
      }
      return '';
    },
    quarterChange(val) {
      console.log('val', val);
      if (val == 'Q1') {
        this.excludesValue = ['04', '05', '06', '07', '08', '09', '10', '11', '12']
      } else if (val == 'Q2') {
        this.excludesValue = ['01', '02', '03', '07', '08', '09', '10', '11', '12']
      } else if (val == 'Q3') {
        this.excludesValue = ['01', '02', '03', '04', '05', '06', '10', '11', '12']
      } else if (val == 'Q4') {
        this.excludesValue = ['01', '02', '03', '04', '05', '06', '07', '08', '09']
      } else {
        this.excludesValue = []
      }
    },
    handleClick(tab, event) {
      if (tab.name == 'first') {
        this.queryCondition.type = 'M'
      } else {
        this.queryCondition.type = ''
      }
      this.queryCondition.pageNum = 1
      this.queryData()
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        status: "",
        year: "",
        quarter: "",
        month: "",
        pageSize: 15,
        pageNum: 1,
      }
      if (this.activeName == 'first') {
        this.queryCondition.type = 'M'
      } else {
        this.queryCondition.type = ''
      }
      this.queryData();
    },
    onDetail(row, index) {
      this.$router.push({
        path: '/qspiFSPI/detail',
        query: {
          scoreStage: row.scoreStage
        }
      })
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onExport() {
      fspiApi.exportQspiFspi(this.queryCondition).then(res => {
        fileService.respToFile(res, 'QSPI_FSPI_Report.xlsx');
      });
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
